import React, { useEffect, useState } from "react";
import PreFilterJoinedBy from "./PreFilterJoinedBy";
import PreFilterTable from "./PreFilterTable";
import ButtonActionIcon from "../ButtonActionIcon";
import { columnOperatorData } from "./operatorData";
import SingleSelectBox from "../../FormComponents/SingleSelectBox";
import { mapArrayToObject } from "../../../commonFunctions/arrayFunc";

const ColumnPreFilters = ({ columnList, columnPreFilters, setColumnPreFilters, tableId }) => {
  const [selectedColumn, setSelectedColumn] = useState("");
  const [allColumns, setAllColumns] = useState(null);
  const handleAddColumn = (obj) => {
    const value = obj.id;
    setSelectedColumn(value);
    const addingColumnData = {
      column_id: value,
      pre_filters: [],
      prefilters_joined_by: ""
    };

    setColumnPreFilters([...columnPreFilters, addingColumnData]);
  };
  // const handleAddColumn = (e) => {
  //   const value = e.target.value;
  //   setSelectedColumn(value);
  //   const addingColumnData = {
  //     column_id: value,
  //     pre_filters: [],
  //     prefilters_joined_by: ""
  //   };

  //   setColumnPreFilters([...columnPreFilters, addingColumnData]);
  // };

  const handlePreFilters = (key, index, preFilters) => {
    const copyOfPreFilters = JSON.parse(JSON.stringify(columnPreFilters));
    copyOfPreFilters[index][key] = preFilters;
    setColumnPreFilters(copyOfPreFilters);
  };

  const deleteColumnPreFilter = (index) => {
    const copyOfPreFilters = JSON.parse(JSON.stringify(columnPreFilters));
    copyOfPreFilters.splice(index, 1);
    setColumnPreFilters(copyOfPreFilters);
  };

  useEffect(() => {
    const { result } = mapArrayToObject(columnList);
    setAllColumns(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!allColumns) return null;
  return (
    <div className="p_3 overflow_scroll" style={{ height: "calc(100vh - 100px)" }}>
      <div className="builder_form">
        <SingleSelectBox
          selectedData={selectedColumn}
          options={columnList}
          labelKey={["display"]}
          onChange={handleAddColumn}
          label="Select Column"
        />
      </div>
      {columnPreFilters.map((column, index) => (
        <React.Fragment key={column.id + index}>
          <div className="d_flex space_between pre_filter_selected_header mt_2">
            <h3>
              {index + 1}. {allColumns[column.column_id].display}
            </h3>
            <ButtonActionIcon type="delete" onClick={() => deleteColumnPreFilter(index)} />
          </div>
          <PreFilterJoinedBy
            prefiltersJoinedBy={column.prefilters_joined_by}
            setPrefiltersJoinedBy={(data) => handlePreFilters("prefilters_joined_by", index, data)}
          />
          <PreFilterTable
            preFilters={column.pre_filters}
            setPreFilters={(data) => handlePreFilters("pre_filters", index, data)}
            tableId={tableId}
            folderId="logged_in_user"
            operatorList={columnOperatorData}
          />
        </React.Fragment>
      ))}
    </div>
  );
};

export default ColumnPreFilters;
